import React from 'react';
import { HomeOutlined, RollbackOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import './ExpiredLink.css'; // Import external CSS

const ExpiredLink = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="expired-container">
      <div className="expired-wrapper">
        <div className="expired-card">
          <div className="expired-background" />
          
          <div className="expired-content">
            <div className="expired-icon">
              <ExclamationCircleOutlined className="icon" />
            </div>

            <h1 className="expired-title">Link Not Found</h1>

            <div className="expired-description">
              <p>This link has been deactivated or deleted by the Admin.</p>
             
            </div>

            <div className="expired-divider">
           
            </div>

            <div className="expired-buttons">
              <button className="btn-home" onClick={handleGoHome}>
                <HomeOutlined />
                Go to Home Page
              </button>

             
            </div>
          </div>
        </div>

       <div className="expired-footer">
  <p>
    Need help? <a href="https://www.sendnow.live/#contact" target="_blank" rel="noopener noreferrer">Contact our support team</a> for assistance.
  </p>
</div>

      </div>
    </div>
  );
};

export default ExpiredLink;
